import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const C = {
  navy: "#1B3A5C",
  teal: "#2A9D8F",
  border: "#D6E4F0",
  bg: "#F4F8FC",
  white: "#FFFFFF",
  muted: "#6B85A3",
  error: "#E63946",
};

export default function AuthCallback() {
  const navigate = useNavigate();
  const [mode, setMode] = useState<"loading" | "reset" | "error">("loading");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    // Supabase met le type dans le hash : #type=recovery&access_token=...
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", ""));
    const type = params.get("type");

    if (type === "recovery") {
      setMode("reset");
    } else {
      // Autre callback (magic link, email confirm...) → dashboard
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMsg("");

    if (password.length < 8) {
      setErrorMsg("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (password !== confirm) {
      setErrorMsg("Les mots de passe ne correspondent pas.");
      return;
    }

    setSubmitting(true);
    const { error } = await supabase.auth.updateUser({ password });
    setSubmitting(false);

    if (error) {
      setErrorMsg("Lien expiré ou invalide — redemandez un email de réinitialisation.");
    } else {
      setSuccess(true);
      setTimeout(() => navigate("/dashboard", { replace: true }), 2500);
    }
  };

  if (mode === "loading") {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: C.bg }}>
        <p style={{ color: C.muted }}>Chargement…</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: C.bg, padding: 16 }}>
      <div style={{ width: "100%", maxWidth: 400, backgroundColor: C.white, borderRadius: 20, padding: 32, border: `1px solid ${C.border}` }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <span style={{ fontSize: 36 }}>🔑</span>
          <h1 style={{ color: C.navy, fontSize: 22, fontWeight: 700, margin: "8px 0 4px" }}>
            Nouveau mot de passe
          </h1>
          <p style={{ color: C.muted, fontSize: 14 }}>
            Choisissez un mot de passe sécurisé (min. 8 caractères)
          </p>
        </div>

        {success ? (
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            <span style={{ fontSize: 32 }}>✅</span>
            <p style={{ color: C.teal, fontWeight: 600, marginTop: 8 }}>
              Mot de passe mis à jour — redirection…
            </p>
          </div>
        ) : (
          <form onSubmit={handleReset} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div>
              <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: C.navy, marginBottom: 6 }}>
                Nouveau mot de passe
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: `1.5px solid ${C.border}`, fontSize: 15, outline: "none", boxSizing: "border-box" }}
              />
            </div>
            <div>
              <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: C.navy, marginBottom: 6 }}>
                Confirmer le mot de passe
              </label>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="••••••••"
                required
                style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: `1.5px solid ${C.border}`, fontSize: 15, outline: "none", boxSizing: "border-box" }}
              />
            </div>

            {errorMsg && (
              <p style={{ color: C.error, fontSize: 13, margin: 0 }}>{errorMsg}</p>
            )}

            <button
              type="submit"
              disabled={submitting}
              style={{ width: "100%", padding: "12px", borderRadius: 12, backgroundColor: C.teal, color: C.white, fontWeight: 700, fontSize: 15, border: "none", cursor: submitting ? "not-allowed" : "pointer", opacity: submitting ? 0.7 : 1 }}
            >
              {submitting ? "Mise à jour…" : "Mettre à jour le mot de passe →"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
